import { createPortal } from 'react-dom'

const Portal = ({ children }) => {
  return createPortal(children, document.getElementById('modal-root'))
}

export { Portal }
